import Profile3D from './Profile3D.vue';
export default Profile3D;
